import { createClient } from "@supabase/supabase-js";
import { publicConfig } from "../config/public";

const { supabaseUrl, supabasePublishableKey } = publicConfig;
export const isSupabaseConfigured = Boolean(
  supabaseUrl && supabasePublishableKey,
);
export const supabase = createClient(supabaseUrl, supabasePublishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
